import _objectSpread from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import React, { createContext, useContext, useMemo } from "react";
//Limitless imports
import { useDevLogging } from "../../../common/hooks/dev-logging/DevLoggingContext";
import { useCustomerMessage } from "./CustomerMessageHook";
import { useCustomerHistoryContext } from "../customer-history/CustomerHistoryContext"; // Set the default state values for each context

var CustomerMessageContext = createContext({});
export var CustomerMessageContextProvider = function CustomerMessageContextProvider(_ref) {
  var children = _ref.children;
  var hook = useCustomerMessage();

  var _useCustomerHistoryCo = useCustomerHistoryContext(),
      history = _useCustomerHistoryCo.history;

  var _useDevLogging = useDevLogging(),
      stateTracker = _useDevLogging.stateTracker;

  var context = useMemo(function () {
    stateTracker.trackState({
      message: hook.message
    });
    return _objectSpread({}, hook);
  }, [hook.message, hook.hasFinishedCreating, history]); // pass the value in provider and return

  return /*#__PURE__*/React.createElement(CustomerMessageContext.Provider, {
    value: context
  }, children);
};
export var useCustomerMessageContext = function useCustomerMessageContext() {
  return useContext(CustomerMessageContext);
};